export class AdminUserProfileChangeController {
  constructor($scope, $rootScope, $http, UserService, PhotoService, RegionService, CityService, PaymentService, toastr, socket, AuthService) {
    $scope.vm = this;
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.http = $http;
    this.UserService = UserService;
    this.PhotoService = PhotoService;
    this.RegionService = RegionService;
    this.AuthService = AuthService;
    this.CityService = CityService;
    this.PaymentService = PaymentService;
    this.toastr = toastr;
    this.scope.allFindUsers = [];
    this.scope.errors = [];
    this.scope.foundUserProfile = {};
    this.scope.sendMessageModel = {};
    this.scope.isModerator = () => {
      return this.AuthService.isModerator;
    };
    // this.scope.allPhotoesHistory = [];
    this.scope.allPhotoesHistorySelected = {
      state: false
    };
    this.scope.allPayments = [];
    this.scope.allPaymentsSelected = {
      state: false
    };
    this.scope.paymentsSelected = {};
    this.scope.regions = [];
    this.scope.allCities = [];
    this.scope.cities = [];
    this.scope.profile = {
      username: ''
    };
    this.scope.step = 0;
    this.scope.total = 0;
    this.scope.page = 0;
    this.scope.limit = 12;

    this.scope.arrayHeight = [];
    this.scope.arrayWeight = [];

    for (var i = 140; i < 221; i++) {
      this.scope.arrayHeight.push(i);
    }

    for (var i = 40; i < 201; i++) {
      this.scope.arrayWeight.push(i);
    }

    this.init();
  }

  init() {

    this.scope.findUsers = () => {
      var request = {
        username: this.scope.profile.username,
        email: this.scope.profile.email,
        registerdate: this.scope.profile.registerdate,
        birthday: this.scope.profile.birthday
      };

      this.UserService.getUserProfilesByName(request)
        .then((response) => { let users = response.data;
          if (users.success) {
            this.scope.allFindUsers = users.data;
            this.scope.changeView(1);
          } else {
            this.scope.changeView(0);
            this.toastr.warning(users.message);
          }
        })
        .catch((response) => { let error = response.data;
          console.log(error);
          this.toastr.error('Can\'t find users');
        });
    }

    this.scope.updateUserProfile = () => {
      if(this.scope.foundUserProfile.status === '3') {
        this.scope.foundUserProfile.status = 0;
        this.scope.foundUserProfile.isBan = true;
      } else if(this.scope.foundUserProfile.status === '4'){
        this.scope.foundUserProfile.status = 3;
        this.scope.foundUserProfile.isBan = false;
      }
      else {
        this.scope.foundUserProfile.isBan = false;
      }

      this.UserService.updateUser(this.scope.foundUserProfile)
        .then((_res) => { let response = _res.data;
          this.toastr.info('Profile was updated');
          this.scope.findUsers();
        })
        .catch((response) => { let err = response.data;
          console.error(err);
        });
    }

    this.scope.changeView = (page) => {
      this.scope.errors = [];
      this.scope.step = page;
    }

    this.scope.sendUserMessageView = (user) => {
      this.scope.sendMessageModel = {
        user: user._id,
        message: '',
        canReply: false
      };
      this.scope.changeView(5);
    }

    this.scope.editUserView = (user) => {
      this.scope.foundUserProfile = angular.copy(user);
      this.scope.foundUserProfile.birthday = new Date(this.scope.foundUserProfile.birthday);
      this.scope.foundUserProfile.lastVisit = new Date(this.scope.foundUserProfile.lastVisit);
      this.scope.foundUserProfile.registerdate = new Date(this.scope.foundUserProfile.registerdate);

      if(this.scope.foundUserProfile.isBan) {
        this.scope.foundUserProfile.status = 3;
      }

      if(this.scope.foundUserProfile.status == 3){
        this.scope.foundUserProfile.status = 4;
      }

      this.scope.changeRegion();
      this.scope.step = 2;
    }

    this.scope.editImagesHistoryView = (user) => {
      this.scope.foundUserProfile = user;
      //this.scope.getPhotoesList(1);
      this.scope.changeView(3);
    }

    this.scope.editPaymentsView = (user) => {
      //this.scope.paymentsHystory = [];
      this.scope.foundUserProfile = user;
      this.scope.getPaymentsList(1);
      this.scope.changeView(4);
    }

    this.scope.addPaymentView = () => {
      this.scope.changeView(6);
      this.scope.newPaymentModel = {
        usertype: '0',
        status: true
      };
    }

    this.scope.editPaymentView = () => {
      if (!this.scope.foundUserProfile.payment) {
        return false;
      }

      const oneDay = 24 * 60 * 60 * 1000;

      this.scope.changeView(7);
      this.scope.newPaymentModel = angular.copy(this.scope.foundUserProfile.payment);

      if (this.scope.foundUserProfile.usertype === +'1') {
        this.scope.newPaymentModel.usertype = '0';
      } else {
        this.scope.newPaymentModel.usertype = '1';
      }

      this.scope.newPaymentModel.days = new Date(this.scope.foundUserProfile.payment.ending).getTime() - new Date(this.scope.foundUserProfile.payment.starting).getTime();
      this.scope.newPaymentModel.days /= oneDay;
      this.scope.newPaymentModel.days = Math.round(this.scope.newPaymentModel.days);
      this.scope.newPaymentModel.status = this.scope.foundUserProfile.payment.status === 1;

      if (this.scope.newPaymentModel.days < 0) {
        this.scope.newPaymentModel.days = 0;
      }
    }


    this.scope.sendUserMessage = (form) => {
      this.scope.errors = [];
      _.forEach(form, (obj, key) => {
        if (key[0] == "$") {
          return;
        }

        _.forEach(obj.$error, (err, keyErr) => {
          if (keyErr == 'required') {
            this.scope.errors.push('The ' + key + ' is required!')
          }
        })
      });

      if (this.scope.errors.length) {
        return false;
      }

      var send = (userId) => {
        this.UserService.sendMessFromPermUser(userId, {
          _id: this.scope.sendMessageModel.user
        }, this.scope.sendMessageModel.message, this.scope.sendMessageModel.canReply);
        this.toastr.info('Message send');
      }


      if (this.rootScope.currentUserProfile.username === 'javiera') {
        send(this.rootScope.currentUserProfile._id);
      } else {
        this.UserService.getUserProfileByName('javiera')
          .then((response) => { let user = response.data;
            send(user.data._id);
          })
          .catch((response) => { let err = response.data;
            console.log(err);
            this.toastr.info('javiera don\'t found');
          })
      }
    }

    this.scope.getPaymentsList = (page) => {
      this.PaymentService.getUserPayments(this.scope.foundUserProfile._id, this.scope.limit, page)
        .then((response) => { let data = response.data;
          this.scope.page = page;
          this.scope.paymentsSelected = {};
          this.scope.allPaymentsSelected.state = false;
          this.scope.total = data.itemCount;
          this.scope.allPayments = data.data;

          _.forEach(this.scope.allPayments, (payment) => {
            this.scope.paymentsSelected[payment._id] = false;
          })
        })
        .catch((response) => { let err = response.data;
          console.error(err);
        })
    }

    this.scope.removePayments = () => {
      _.forEach(this.scope.paymentsSelected, (val, key) => {
        if (val) {
          this.PaymentService.removePayment(key)
            .then((response) => {
              this.scope.getPaymentsList(1);
            })
            .catch((response) => { let err = response.data;
              console.error(err);
            })
        }
      })
    }

    this.scope.createPayment = (form) => {
      this.scope.errors = [];
      _.forEach(form, (obj, key) => {
        if (key[0] == "$") {
          return;
        }

        _.forEach(obj.$error, (err, keyErr) => {
          if (keyErr == 'required') {
            this.scope.errors.push('The ' + key + ' is required!')
          }
        })
      });

      if (this.scope.newPaymentModel.days < 1) {
        this.scope.errors.push('Days must be greater than 0')
      }

      if (this.scope.newPaymentModel.days > 1000) {
        this.scope.errors.push('Days should be less than 1000')
      }

      if (this.scope.errors.length) {
        return false;
      }

      const oneDay = 24 * 60 * 60 * 1000;
      const days = this.scope.newPaymentModel.days * oneDay;

      var newPayment = {
        starting: new Date(),
        ending: new Date(new Date().getTime() + days),
        fee: 0,
        type: 0,
        status: +this.scope.newPaymentModel.status,
        user: this.scope.foundUserProfile._id,
        system_payment: {
          "SYSTEM": "MANUAL"
        }
      };

      switch(this.scope.newPaymentModel.usertype) {
        case '0':
          newPayment.type = +'2';
          newPayment.usertype = +'2';
          newPayment.system_payment.SYSTEM = "TRIAL";
          break;
        case '1':
          newPayment.type = +'1';
          newPayment.usertype = +'4';
          break;
        case '2':
          newPayment.type = +'1';
          newPayment.usertype = +'4';
          newPayment.system_payment.SYSTEM = "MANUAL PURCHASE";
          newPayment.fee = this.scope.newPaymentModel.fee;
          break;
      }

      //save new payment
      this.PaymentService.createPayment(newPayment)
        .then((response) => { let data = response.data;
          //this.scope.findUsers();
          this.scope.getPaymentsList();
          this.scope.findUsers();
          this.toastr.info('Payment save success');
        })
        .catch((response) => { let error = response.data;
          console.log(error);
        })
    }

    this.scope.selectAllPayments = () => {
      var check = this.scope.allPaymentsSelected.state;
      this.scope.paymentsSelected = {};

      _.forEach(this.scope.allPayments, (payment, key) => {
        this.scope.paymentsSelected[payment._id] = !!check;
      })
    }

    this.scope.selectAllPhotoesHistory = () => {
      var check = this.scope.allPhotoesHistorySelected.state;

      _.forEach(this.scope.foundUserProfile.photoprofileHistory, (photo, key) => {
        photo.state = check;
      })
    }

    this.scope.approveProfilePhoto = () => {
      this.PhotoService.approveAvatar({
          id: this.scope.foundUserProfile._id,
          checked: true
        })
        .then((response) => { let user = response.data;
          this.scope.foundUserProfile.photoprofile = user.data.photoprofile;
        })
        .catch((response) => { let error = response.data;
          console.log(error);
        });
    }

    this.scope.rejectProfilePhoto = () => {
      this.PhotoService.rejectAvatar({
          id: this.scope.foundUserProfile._id,
          checked: true
        })
        .then((response) => { let user = response.data;
          this.scope.foundUserProfile.photoprofile = user.data.photoprofile;
        })
        .catch((response) => { let error = response.data;
          console.log(error);
        });
    }

    this.scope.removePhotoProfile = () => {
      this.scope.foundUserProfile.photoprofile = {
        approved: true,
        feedback: false,
        url: '',
        newUrl: '',
        origin: '',
        change_at: new Date()
      };

      this.scope.updateUserProfile();
    }

    this.scope.removePhotoesFromHistory = () => {
      var newPhotoList = [];

      _.forEach(this.scope.foundUserProfile.photoprofileHistory, (photo, key) => {
        if (!photo.state) {
          newPhotoList.push(photo);
        }
      });

      this.scope.foundUserProfile.photoprofileHistory = newPhotoList;
      this.scope.updateUserProfile();
    }

    //Get regions from db
    this.RegionService.getRegionsList()
      .then((response) => { let regions = response.data;
        this.scope.regions = [];
        _(regions.data).forEach((region) => {
          this.scope.regions.push({
            _id: region._id,
            name: region.name
          });
        }).value();
      })
      .catch((response) => { let error = response.data;
        console.log("Can`t get regions from database");
      });


    //Get cities from db
    this.CityService.getCitiesList()
      .then((response) => { let cities = response.data;
        _(cities.data).forEach((city) => {
          this.scope.allCities.push({
            _id: city._id,
            region: city.region,
            name: city.name
          });
        }).value();
      })
      .catch((response) => { let error = response.data;
        console.log("Can`t get cities from database");
      });

    this.scope.cancel = () => {
      this.scope.changeView(1);
      //this.scope.step = 1;
    }

    this.scope.changeRegion = () => {
      this.scope.cities = [];
      var region = this.scope.foundUserProfile.region;

      _(this.scope.allCities).forEach((city) => {
        if (city.region == region) {
          this.scope.cities.push(city);
        }
      }).value();
    }
  }

}
